/**
 * @Description Fasat Expandable Panel component page
 * @FileName fasatExpandablePanel.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 13 May, 2021 10:15:58
 * @IssueID 950
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '@manulife/mux';
import './fasatExpandablePanel.scss';

function FasatExpandablePanel(props) {
  const { children, title, 'data-testid': dataTestId, expandedByDefault, expanded, id, ...rest } = props;

  // Use controlled 'expanded' if provided, otherwise use 'defaultExpanded' for uncontrolled
  const accordionProps = expanded !== undefined
    ? { expanded, ...rest }
    : { defaultExpanded: expandedByDefault, ...rest };

  // Generate aria-labelledby pointing to the header for accessibility
  const ariaLabelledBy = id ? `${id}-header` : undefined;

  return (
    <div className="fasatExpandablePanel">
      <Accordion
        {...accordionProps}
        id={id}
        title={title}
        data-testid={dataTestId}
        aria-labelledby={ariaLabelledBy}
      >
        {children}
      </Accordion>
    </div>
  );
}

FasatExpandablePanel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape()),
  'data-testid': PropTypes.string,
  expandedByDefault: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  id: PropTypes.string,
};

FasatExpandablePanel.defaultProps = {
  children: '',
  'data-testid': undefined,
  expandedByDefault: false,
  expanded: undefined,
  onToggle: undefined,
  id: undefined,
};

export default FasatExpandablePanel;
